/* Sunnah Goods (Gilded) storefront script.
   Ported from the Homepage V2 prototype. Cart uses the Shopify AJAX cart API,
   search uses Shopify predictive search. Works with the theme editor. */
(function () {
  'use strict';
  var d = document, b = d.body;
  var $ = function (s, r) { return (r || d).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };
  var SG = window.SG || { routes: {} };
  var R = SG.routes || {};
  var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && matchMedia('(hover:hover) and (pointer:fine)').matches;
  var design = !!SG.designMode;
  var hasGSAP = typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined';
  if (hasGSAP) gsap.registerPlugin(ScrollTrigger);

  /* ---------- money ---------- */
  function money(cents) {
    var fmt = SG.moneyFormat || '${{amount}}';
    cents = Number(cents) || 0;
    function f(n, dec, ts, ds) {
      var s = (n / 100).toFixed(dec).split('.');
      s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return s[1] ? s[0] + ds + s[1] : s[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return f(cents, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return f(cents, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return f(cents, 0, '.', ',');
      return f(cents, 2, ',', '.');
    });
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- preloader ---------- */
  var loader = $('#loader');
  if (loader) {
    var lw = $('#loader-word');
    if (lw) 'SUNNAH GOODS'.split('').forEach(function (c, i) { var s = d.createElement('span'); s.textContent = c === ' ' ? ' ' : c; s.style.animationDelay = (i * 18) + 'ms'; lw.appendChild(s); });
    var finish = function () { loader.classList.add('done'); b.classList.add('loaded'); setTimeout(function () { loader.remove(); if (hasGSAP) ScrollTrigger.refresh(); }, 700); };
    if (reduced) { loader.remove(); b.classList.add('loaded'); } else setTimeout(finish, 550);
  } else b.classList.add('loaded');

  /* ---------- smooth scroll ---------- */
  var lenis = null;
  if (!reduced && !design && typeof Lenis !== 'undefined') {
    lenis = new Lenis({ lerp: .09, smoothWheel: true });
    if (hasGSAP) { lenis.on('scroll', ScrollTrigger.update); gsap.ticker.add(function (t) { lenis.raf(t * 1000); }); gsap.ticker.lagSmoothing(0); }
    else { var raf = function (t) { lenis.raf(t); requestAnimationFrame(raf); }; requestAnimationFrame(raf); }
  }

  /* ---------- world (day / night) + scrolled state ---------- */
  function setWorld(w) { if (b.dataset.world !== w) b.dataset.world = w; }
  var wio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) setWorld(e.target.dataset.world); }); }, { rootMargin: '-45% 0px -45% 0px' });
  function initWorlds(root) { $$('main [data-world], footer[data-world]', root).forEach(function (el) { wio.observe(el); }); }
  var onScroll = function () { b.classList.toggle('scrolled', (window.scrollY || d.documentElement.scrollTop) > 40); };
  window.addEventListener('scroll', onScroll, { passive: true }); onScroll();

  /* ---------- reveals ---------- */
  var rio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); rio.unobserve(e.target); } }); }, { rootMargin: '0px 0px -10% 0px', threshold: .08 });
  function initReveals(root) { $$('.rv, .mask', root).forEach(function (el) { if (design) el.classList.add('in'); else rio.observe(el); }); }

  /* ---------- hero slideshow ---------- */
  function initHero(hero) {
    if (!hero || hero._sg) return; hero._sg = true;
    var slides = $$('.hero-slide', hero), panels = $$('.hero-panel', hero), pauseBtn = $('[data-hero-pause]', hero), copy = $('[data-hero-copy]', hero);
    if (!slides.length) return;
    var cur = 0, timer = null, paused = false, hover = false, DUR = +hero.dataset.interval || 3000;
    function go(n, user) {
      n = (n + slides.length) % slides.length; if (n === cur && user === undefined) return;
      slides[cur].classList.remove('is-active'); if (panels[cur]) panels[cur].classList.remove('is-active');
      cur = n; slides[cur].classList.add('is-active'); if (panels[cur]) panels[cur].classList.add('is-active');
      if (user) restart();
    }
    hero._go = go;
    function tick() { if (!paused && !hover && !d.hidden) go(cur + 1); }
    function restart() { clearInterval(timer); if (!reduced && slides.length > 1) timer = setInterval(tick, DUR); }
    if (copy) { copy.addEventListener('mouseenter', function () { hover = true; }); copy.addEventListener('mouseleave', function () { hover = false; }); copy.addEventListener('focusin', function () { hover = true; }); copy.addEventListener('focusout', function () { hover = false; }); }
    hero.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') go(cur + 1, true); if (e.key === 'ArrowLeft') go(cur - 1, true); });
    if (pauseBtn) pauseBtn.addEventListener('click', function () { paused = !paused; pauseBtn.setAttribute('aria-pressed', String(paused)); pauseBtn.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow'); hero.classList.toggle('is-paused', paused); });
    var tx = 0; hero.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', function (e) { var dx = e.changedTouches[0].clientX - tx; if (Math.abs(dx) > 50) go(cur + (dx < 0 ? 1 : -1), true); }, { passive: true });
    setTimeout(function () { hero.classList.add('is-ready'); if (!design) restart(); }, reduced ? 0 : 500);
  }

  /* ---------- story scrub + fragrance parallax ---------- */
  function initStory(sec) {
    var big = $('[data-story-big]', sec); if (!big || big._sg) return; big._sg = true;
    big.innerHTML = big.textContent.trim().split(/\s+/).map(function (w) { return '<span class="w">' + esc(w) + '</span>'; }).join(' ');
    var words = $$('.w', big);
    if (hasGSAP && !reduced && !design) {
      ScrollTrigger.create({ trigger: big, start: 'top 80%', end: 'bottom 45%', scrub: true, onUpdate: function (st) { var n = Math.floor(st.progress * words.length); words.forEach(function (w, i) { w.classList.toggle('on', i <= n); }); } });
    } else words.forEach(function (w) { w.classList.add('on'); });
  }
  function initFrag(sec) {
    var bg = $('[data-frag-bg]', sec); if (!bg || bg._sg) return; bg._sg = true;
    if (hasGSAP && !reduced && !design) gsap.to(bg, { yPercent: -6, ease: 'none', scrollTrigger: { trigger: sec, start: 'top bottom', end: 'bottom top', scrub: true } });
  }

  /* ---------- tilt + spotlight (desktop) ---------- */
  function initTilt(root) {
    if (!fine || reduced) return;
    $$('.card .card-media', root).forEach(function (el) {
      if (el._sg) return; el._sg = true; var host = el.closest('.card');
      host.addEventListener('pointermove', function (e) { var r = el.getBoundingClientRect(); var x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5; el.style.transform = 'rotateX(' + (-y * 6).toFixed(2) + 'deg) rotateY(' + (x * 6).toFixed(2) + 'deg) translateZ(0)'; });
      host.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });
    $$('.spot', root).forEach(function (c) { if (c._sg) return; c._sg = true; c.addEventListener('pointermove', function (e) { var r = c.getBoundingClientRect(); c.style.setProperty('--mx', (e.clientX - r.left) + 'px'); c.style.setProperty('--my', (e.clientY - r.top) + 'px'); }); });
  }

  function initSections(root) {
    root = root || d;
    initReveals(root); initWorlds(root); initTilt(root);
    $$('[data-sg-hero]', root).forEach(initHero);
    $$('[data-sg-story]', root).forEach(initStory);
    $$('[data-sg-frag]', root).forEach(initFrag);
    if (hasGSAP) ScrollTrigger.refresh();
  }

  /* ---------- drawers ---------- */
  var lastFocus = null;
  function openDrawer(id, btn) {
    var dr = d.getElementById(id); if (!dr) return;
    dr.dataset.open = 'true'; if (lenis) lenis.stop(); b.style.overflow = 'hidden'; lastFocus = btn || d.activeElement;
    var f = dr.querySelector('input,button,a,summary'); if (f) setTimeout(function () { f.focus(); }, 60);
    if (btn) btn.setAttribute('aria-expanded', 'true');
    if (id === 'drawer-search') { b.classList.remove('hx-hide'); var inp = $('#search-input'); if (inp) setTimeout(function () { inp.focus(); inp.select(); }, 80); }
  }
  function closeDrawers() {
    $$('.drawer[data-open="true"]').forEach(function (dr) { dr.dataset.open = 'false'; var bt = $('[aria-controls="' + dr.id + '"]'); if (bt) bt.setAttribute('aria-expanded', 'false'); });
    if (lenis) lenis.start(); b.style.overflow = ''; if (lastFocus) { lastFocus.focus(); lastFocus = null; }
  }
  d.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('#open-menu')) { openDrawer('drawer-menu', t.closest('#open-menu')); return; }
    if (t.closest('#open-search')) { openDrawer('drawer-search', t.closest('#open-search')); return; }
    if (t.closest('#open-cart')) { e.preventDefault(); openDrawer('drawer-cart', t.closest('#open-cart')); return; }
    if (t.closest('[data-close]')) { closeDrawers(); return; }
    if (t.closest('[data-hx-search]')) { var m = $('#drawer-menu'); if (m) m.dataset.open = 'false'; setTimeout(function () { openDrawer('drawer-search', $('#open-search')); }, 60); return; }
    var q = t.closest('[data-hq]'); if (q) { var inp = $('#search-input'); inp.value = q.dataset.hq; runSearch(inp.value); inp.focus(); return; }
  });
  d.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawers(); closeMega(); }
    if (e.key === '/' && !/input|textarea|select/i.test(e.target.tagName || '') && !e.target.isContentEditable) { var sb = $('#open-search'); if (sb) { e.preventDefault(); openDrawer('drawer-search', sb); } }
  });

  /* ---------- mega menus ---------- */
  function megaOf(li) { var bt = li.querySelector(':scope > button'); return bt ? d.getElementById(bt.getAttribute('aria-controls')) : null; }
  function setOpen(li, on) { var bt = li.querySelector(':scope > button'); if (!bt) return; bt.setAttribute('aria-expanded', String(on)); var m = megaOf(li); if (m) m.dataset.open = String(on); }
  function closeMega(ex) { $$('.nav-desktop > li').forEach(function (l) { if (l !== ex) setOpen(l, false); }); }
  function initHeader() {
    var nav = $('#nav-desktop'); if (!nav || nav._sg) return; nav._sg = true;
    var lis = $$(':scope > li', nav), tOpen, tClose;
    lis.forEach(function (li) {
      var bt = li.querySelector(':scope > button');
      if (bt) bt.addEventListener('click', function (e) { var open = bt.getAttribute('aria-expanded') === 'true'; var next = (open && e.detail === 0) ? false : true; closeMega(li); setOpen(li, next); });
      li.addEventListener('mouseenter', function () { clearTimeout(tClose); clearTimeout(tOpen); var cur = $('.hx-mega[data-open="true"]'); var go = function () { closeMega(li); setOpen(li, true); }; if (cur && !li.contains(cur)) tOpen = setTimeout(go, 150); else go(); });
      li.addEventListener('mouseleave', function () { clearTimeout(tOpen); clearTimeout(tClose); tClose = setTimeout(function () { if (!li.matches(':hover')) setOpen(li, false); }, 280); });
    });
    d.addEventListener('click', function (e) { if (!e.target.closest('.nav-desktop')) closeMega(); });
    new MutationObserver(function () { b.classList.toggle('hx-mopen', !!$('.hx-mega[data-open="true"]')); }).observe(nav, { attributes: true, subtree: true, attributeFilter: ['data-open'] });
    /* preview swap */
    $$('.hx-mega', nav).forEach(function (m) {
      var pv = $('.hx-pv', m); if (!pv) return;
      var A = $('.hx-pv-im img:not(.b)', pv), B = $('.hx-pv-im img.b', pv), T = $('.hx-pv-tx b', pv), D = $('.hx-pv-tx small', pv);
      var def = { src: A.getAttribute('src'), t: T.textContent, d: D.textContent, h: pv.getAttribute('href') }, cur = def.src, loaded = false;
      function show(src, t, dd, h) { T.textContent = t; D.textContent = dd; pv.setAttribute('href', h); if (src === cur) return; cur = src; var top = A.style.opacity === '0' ? B : A, bot = top === A ? B : A; bot.src = src; var go = function () { bot.style.opacity = '1'; top.style.opacity = '0'; }; if (bot.complete && bot.naturalWidth) go(); else bot.onload = go; }
      function warm() { if (loaded) return; loaded = true; $$('[data-pv]', m).forEach(function (a) { var im = new Image(); im.src = a.dataset.pv; }); }
      $$('[data-pv]', m).forEach(function (a) { var f = function () { warm(); $$('.hx-col a.on', m).forEach(function (x) { x.classList.remove('on'); }); a.classList.add('on'); show(a.dataset.pv, a.dataset.pt, a.dataset.pd, a.getAttribute('href')); }; a.addEventListener('mouseenter', f); a.addEventListener('focus', f); });
      m.addEventListener('mouseenter', warm);
      new MutationObserver(function () { if (m.dataset.open !== 'true') { $$('.hx-col a.on', m).forEach(function (x) { x.classList.remove('on'); }); show(def.src, def.t, def.d, def.h); } }).observe(m, { attributes: true, attributeFilter: ['data-open'] });
    });
    /* current section */
    var here = location.pathname.replace(/\/$/, '') || '/';
    lis.forEach(function (li) {
      var urls = [li.dataset.url].concat($$('a[href]', li).map(function (a) { return a.getAttribute('href'); }));
      if (here !== '/' && urls.some(function (u) { return u && u.split('?')[0].replace(/\/$/, '') === here; })) li.classList.add('hx-cur');
    });
    $$('.hx-strip a').forEach(function (a) { if (here !== '/' && a.getAttribute('href').replace(/\/$/, '') === here) a.classList.add('cur'); });
    var cs = $('.hx-strip a.cur'); if (cs) cs.scrollIntoView({ block: 'nearest', inline: 'center' });
  }
  /* announcement ticker */
  function initTicker() {
    var tk = $('#hx-tick'); if (!tk || tk._sg) return; tk._sg = true;
    var it = $$(':scope > span', tk), i = 0, paused = false;
    tk.addEventListener('mouseenter', function () { paused = true; }); tk.addEventListener('mouseleave', function () { paused = false; });
    if (!reduced && it.length > 1) setInterval(function () { if (paused || d.hidden) return; var a = it[i]; a.classList.remove('on'); a.classList.add('out'); i = (i + 1) % it.length; var n = it[i]; n.classList.remove('out'); n.classList.add('on'); setTimeout(function () { a.classList.remove('out'); }, 700); }, 4200);
  }
  /* hide header on scroll down */
  var ly = window.scrollY || 0, ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () { var y = window.scrollY || 0, open = $('.mega[data-open="true"],.drawer[data-open="true"]'); if (!open && y > ly + 6 && y > 360) b.classList.add('hx-hide'); else if (y < ly - 6 || y < 160) b.classList.remove('hx-hide'); ly = y; ticking = false; });
  }, { passive: true });

  /* ---------- toast ---------- */
  var toastT;
  function toast(msg, cartLink) {
    var t = $('#toast'); if (!t) return; t.textContent = msg;
    if (cartLink) { var bt = d.createElement('button'); bt.type = 'button'; bt.className = 'toast-btn'; bt.textContent = 'View cart'; bt.addEventListener('click', function () { t.dataset.show = 'false'; openDrawer('drawer-cart', $('#open-cart')); }); t.appendChild(bt); }
    t.dataset.show = 'true'; clearTimeout(toastT); toastT = setTimeout(function () { t.dataset.show = 'false'; }, cartLink ? 4200 : 2600);
  }

  /* ---------- cart (Shopify AJAX API) ---------- */
  var FREE = SG.freeShip || 10000;
  function imgUrl(u, w) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function renderCart(cart) {
    var ul = $('#cart-lines'); if (!ul) return;
    ul.innerHTML = '';
    cart.items.forEach(function (it) {
      var li = d.createElement('li'); li.className = 'cart-line';
      var vt = it.variant_title && it.variant_title !== 'Default Title' ? '<div class="cart-v">' + esc(it.variant_title) + '</div>' : '';
      li.innerHTML = '<a href="' + esc(it.url) + '"><img src="' + esc(imgUrl(it.image, 160)) + '" width="64" height="80" alt=""></a><div><div><b>' + esc(it.product_title) + '</b></div>' + vt + '<div>' + money(it.final_line_price) + '</div></div><div class="qty"><button type="button" aria-label="Decrease quantity" data-dec="' + esc(it.key) + '" data-q="' + it.quantity + '">−</button><span style="padding:0 .4rem;line-height:32px">' + it.quantity + '</span><button type="button" aria-label="Increase quantity" data-inc="' + esc(it.key) + '" data-q="' + it.quantity + '">+</button></div>';
      ul.appendChild(li);
    });
    var count = cart.item_count, sub = cart.total_price;
    var em = $('#cart-empty'); if (em) em.hidden = count > 0;
    var co = $('#checkout-btn'); if (co) { co.classList.toggle('is-disabled', count === 0); co.setAttribute('aria-disabled', String(count === 0)); }
    var cc = $('#cart-count'); if (cc) { cc.textContent = count; cc.hidden = count === 0; }
    var st = $('#cart-subtotal'); if (st) st.textContent = money(sub);
    var oc = $('#open-cart'); if (oc) oc.setAttribute('aria-label', 'Cart, ' + count + ' item' + (count === 1 ? '' : 's'));
    var left = Math.max(0, FREE - sub);
    var stx = $('#ship-text'); if (stx) stx.textContent = left > 0 ? 'Add ' + money(left) + ' for free U.S. shipping' : 'You qualify for free U.S. shipping';
    var sf = $('#ship-fill'); if (sf) sf.style.width = Math.min(100, sub / FREE * 100) + '%';
    return cart;
  }
  function getCart() { return fetch(R.cartJs || '/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(renderCart); }
  function post(url, body) { return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); }); }
  d.addEventListener('click', function (e) {
    var add = e.target.closest('[data-add]');
    if (add) {
      e.preventDefault(); if (add.disabled) return; add.disabled = true; add.classList.add('is-busy');
      post(R.cartAdd || '/cart/add.js', { items: [{ id: +add.dataset.add, quantity: 1 }] })
        .then(getCart)
        .then(function (cart) { var left = FREE - cart.total_price; toast(left > 0 ? 'Added. ' + money(left) + ' more for free U.S. shipping.' : 'Added. Your order ships free in the U.S.', true); })
        .catch(function (err) { toast((err && (err.description || err.message)) || 'Could not add this item. Please try again.'); })
        .then(function () { add.disabled = false; add.classList.remove('is-busy'); });
      return;
    }
    var ch = e.target.closest('[data-inc],[data-dec]');
    if (ch) {
      var key = ch.dataset.inc || ch.dataset.dec, q = +ch.dataset.q + (ch.dataset.inc ? 1 : -1);
      post(R.cartChange || '/cart/change.js', { id: key, quantity: Math.max(0, q) }).then(renderCart).catch(function (err) { toast((err && err.description) || 'Could not update the cart.'); });
    }
  });
  var co0 = $('#checkout-btn'); if (co0) co0.addEventListener('click', function (e) { if (co0.getAttribute('aria-disabled') === 'true') e.preventDefault(); });

  /* ---------- predictive search ---------- */
  var sInp, sRes, sHint, sBox, sPages, sCnt, sTimer, sCtl, sel = -1;
  function runSearch(v) {
    var q = (v || '').trim(); sel = -1;
    if (!q) { sHint.hidden = false; sBox.hidden = true; sRes.innerHTML = ''; return; }
    clearTimeout(sTimer);
    sTimer = setTimeout(function () {
      if (sCtl) sCtl.abort(); sCtl = window.AbortController ? new AbortController() : null;
      var url = (R.predictive || '/search/suggest.json') + '?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,page&resources[limit]=10&resources[options][unavailable_products]=last';
      fetch(url, sCtl ? { signal: sCtl.signal } : {}).then(function (r) { return r.json(); }).then(function (j) {
        var res = (j && j.resources && j.resources.results) || {}, P = res.products || [], C = (res.collections || []).concat(res.pages || []);
        sHint.hidden = true; sBox.hidden = false;
        sPages.innerHTML = C.slice(0, 4).map(function (c) { return '<a href="' + esc(c.url) + '">' + esc(c.title) + '</a>'; }).join('');
        sCnt.textContent = P.length ? (P.length + ' product' + (P.length === 1 ? '' : 's')) : '';
        var words = q.toLowerCase().split(/\s+/).filter(function (w) { return w.length > 1; });
        function hl(t) { var e = esc(t); words.forEach(function (w) { e = e.replace(new RegExp('(' + w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig'), '<mark>$1</mark>'); }); return e; }
        sRes.innerHTML = P.length ? P.map(function (p) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
          var price = p.price_min !== undefined ? p.price_min : p.price;
          var cents = Math.round(parseFloat(price) * 100) || 0;
          return '<li><a class="hx-hit" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(imgUrl(img, 120)) + '" alt="" loading="lazy" width="56" height="56">' : '<span></span>') + '<span><b>' + hl(p.title) + '</b><small>' + esc(p.type || p.vendor || '') + '</small></span><i>' + money(cents) + '</i></a></li>';
        }).join('') + '<li class="cart-empty" style="padding:.6rem .25rem"><a href="' + (R.search || '/search') + '?q=' + encodeURIComponent(q) + '&type=product">See all results for "' + esc(q) + '"</a></li>'
          : '<li class="cart-empty" style="padding:.6rem 0">No products match "' + esc(q) + '". Try thobe, oud, kohl or Quran.</li>';
      }).catch(function () {});
    }, 140);
  }
  function initSearch() {
    sInp = $('#search-input'); if (!sInp || sInp._sg) return; sInp._sg = true;
    sRes = $('#search-results'); sHint = $('#search-hint'); sBox = $('#hx-res'); sPages = $('#hx-pages'); sCnt = $('#hx-count');
    sInp.addEventListener('input', function () { runSearch(sInp.value); });
    sInp.addEventListener('keydown', function (e) {
      var L = $$('.hx-hit', sRes); if (!L.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); sel = (sel + (e.key === 'ArrowDown' ? 1 : -1) + L.length) % L.length; L.forEach(function (a, k) { a.setAttribute('aria-selected', String(k === sel)); }); L[sel].scrollIntoView({ block: 'nearest' }); }
      else if (e.key === 'Enter' && sel >= 0) { e.preventDefault(); L[sel].click(); }
    });
  }

  /* ---------- public helpers for section scripts (collection pages) ---------- */
  SG.open = openDrawer; SG.close = closeDrawers; SG.toast = toast; SG.money = money; SG.esc = esc; SG.reveal = function (r) { initReveals(r || d); };
  SG.add = function (items) {
    return post(R.cartAdd || '/cart/add.js', { items: items })
      .then(getCart)
      .then(function (cart) { var left = FREE - cart.total_price; toast(left > 0 ? 'Added. ' + money(left) + ' more for free U.S. shipping.' : 'Added. Your order ships free in the U.S.', true); return cart; })
      .catch(function (err) { toast((err && (err.description || err.message)) || 'Could not add this item. Please try again.'); throw err; });
  };
  window.SG = SG;

  /* ---------- boot ---------- */
  function boot() { initHeader(); initTicker(); initSearch(); initSections(d); getCart().catch(function () {}); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('load', function () { if (hasGSAP) ScrollTrigger.refresh(); });

  /* theme editor support */
  d.addEventListener('shopify:section:load', function (e) { initHeader(); initTicker(); initSearch(); initSections(e.target); });
  d.addEventListener('shopify:block:select', function (e) {
    var hero = e.target.closest('[data-sg-hero]'); if (hero && hero._go) hero._go(+e.target.dataset.slide || 0, true);
    var mega = e.target.closest('.hx-mega'); if (mega) mega.dataset.open = 'true';
  });
  d.addEventListener('shopify:block:deselect', function (e) { var mega = e.target.closest('.hx-mega'); if (mega) mega.dataset.open = 'false'; });
})();
